// extracted by mini-css-extract-plugin
export default {"headerForm":"HelpForm_headerForm__rR30N","submitButton":"HelpForm_submitButton__8CWHK"};